import { DrawerDiaLog, DrawerDiaLogTitle } from '../drawer-dialog';
import { SignInfo } from './signin-info';

type UserSignInProps = {
  className?: string;
  open: boolean;
  setOpen: (open: boolean) => void;
};
export const UserSignInModel = ({ open, setOpen }: UserSignInProps) => {
  return (
    <DrawerDiaLog open={open} setOpen={setOpen} className="w-full md:max-w-sm border border-foreground/4">
      <DrawerDiaLogTitle />
      <SignInfo onClose={() => setOpen?.(false)} />
    </DrawerDiaLog>
  );
};

export default UserSignInModel;
